import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from './ui/button';
import AboutImg1 from '@/assets/images/about-img-1.png';
import AboutImg2 from '@/assets/images/about-img-2.png';
import AboutImg3 from '@/assets/images/about-img-3.png';
import AboutImg4 from '@/assets/images/about-img-4.png';
import { ThumbsUp } from 'lucide-react';

const rules = [
  {
    text: 'Запустите Хоумы на компьютере, телефоне или ТВ',
    img: AboutImg1,
  },
  {
    text: 'Соберите всех игроков перед экраном',
    img: AboutImg2,
  },
  {
    text: 'Приготовьте бумажки, заметки на телефоне – или не парьтесь и отвечайте вслух',
    img: AboutImg3,
  },
  {
    text: 'Выберите игру по вкусу и вперед!',
    img: AboutImg4,
  },
];

function RuleRow({ num, text, img }: any) {
  return (
    <div className="flex justify-between items-start gap-4">
      <div className="flex items-center gap-2 flex-1 h-full">
        <div className="w-[2rem] md:w-[4rem] flex-shrink-0">
          <span className="text-customYellow-300 font-extrabold text-yellow-300 text-md md:text-3xl">
            #{num}
          </span>
        </div>
        <div className="text-md md:text-xl">{text}</div>
      </div>
      <div className="w-[8.4rem] flex-shrink-0 hidden md:block">
        <img src={img} className="w-full h-auto" />
      </div>
    </div>
  );
}

export function RulesPopup() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="secondary"
          className="ml-0 py-3 px-4 md:py-4 md:px-6 rounded-[1rem] md:rounded-[1.25rem] "
        >
          <span className="text-base md:text-xl">Как играть?</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="user-layout max-w-[48rem]" aria-describedby="">
        <DialogHeader className="mb-4">
          <h3 className="text-2xl md:text-3xl font-extrabold text-customPurple-100">
            Начать играть - просто
          </h3>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          {rules.map((rule, index) => (
            <RuleRow num={index + 1} text={rule.text} img={rule.img} />
          ))}
        </div>
        <DialogClose asChild>
          <Button
            variant="default"
            className="w-full md:w-min mt-6 md:mt-4 py-3 px-4 md:py-4 md:px-6 rounded-[1rem] md:rounded-[1.25rem] "
          >
            <ThumbsUp />
            <span className="text-base md:text-xl">Все понятно</span>
          </Button>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
}
